import "./index.scss";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Chart from "../components/chart";
import PdfIndicators from "../components/post-credit-pdf";
import ChartSingleBar from "../components/chartSingleBar";
import Matriz from "../../../components/matriz";
import { StepIndicators } from "../../../mocks/default";
import StepComponent from "../../../components/step-component";
import PlanejadoraLogo from "../../../assets/images/logo-planejadora.svg";
import { useContext, useEffect, useState } from "react";
import { BaSeButton, BaSeIcon, BaSeDatePicker } from "@base/react";
import ApiPlannings from "../../../services/planning";
import { toast } from "react-toastify";
import ToastContent from "../../../components/toastContent";
import Loading from "../../../components/loading";
import AccordionGraphics from "../../../components/accordion-graphics";
import Button from "../../../components/button/button";
import MonthlyAverage from "../../planning/components/sections/monthly-average";
import VariableIndirectCosts from "../../planning/components/sections/variable-indirect-costs";
import TotalInvestment from "../../planning/components/sections/total-investment";
import { transformDataToFormModel } from "../../planning/components/functions";
import PostCreditSection from "./postCreditSection";
import PostCreditCashFlow from "./postCreditCashFlow";
import {
  lucroMessage,
  lucratividadeMessage,
  rentabilidadeMessage,
  ncgMessage,
  nfcgMessage,
  inadimplenciaMessage,
  cmlMessage,
  geeMessage,
} from "../mocks/messages";
import {
  formatCloseMonthData,
  formatStep2ForSave,
  formatStep3ForSave,
  formatStep4ForSave,
  formatStep5ForSave,
  formatStep6ForSave,
  formatStep7ForSave,
  formatStep9ForSave,
} from "./functions";
import moment from "moment";
import { useParams } from "react-router-dom";
import {decodeJWT, eventTag, getToken} from "../../../services/utils";
import { AppContext } from "../../../context/app";

const apiPlannings = ApiPlannings();

const PostCreditResult = ({
                            isOpen,
                            setOpenModal,
                            handleClose,
                            date,
                            monthId,
                            firstMonth,
                            refreshPlannings,
                            planningTitle,
                            eventGA,
                          }) => {
  const { postCreditId: planningId } = useParams();
  const token = decodeJWT(getToken());
  const { companies } = useContext(AppContext);

  const [filterRange, setFilterRange] = useState({
    start: null,
    end: null,
  });
  const [rangeLimits, setRangeLimits] = useState({
    minStart: null,
    maxEnd: null,
  });
  const [isCompleted, setIsCompleted] = useState();
  const [showDateFilter, setShowDateFilter] = useState(false);
  const [stepActive, setStepActive] = useState(0);
  const [animationInProgress, setAnimationInProgress] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [planningData, setPlanningData] = useState({});
  const [loading, setLoading] = useState(false);
  const [cashFlowInfoCollapsed, setCashFlowInfoCollapsed] = useState(false);
  const [updatingStep, setUpdatingStep] = useState(null);
  const [openedSections, setOpenedSections] = useState([]);
  const [closedMonth, setClosedMonth] = useState(false);
  const [role, setRole] = useState("visualizador");
  const [pdfInfo, setPdfInfo] = useState(null);

  const [indicators, setIndicators] = useState({
    desempenho: null,
    endividamento: null,
    matriz: null,
  });

  // Step data states
  const [step2Data, setStep2Data] = useState({
    cif: 0,
    cmp: 0,
    cms: 0,
    rtp: 0,
    rts: 0,
  });

  const [step3Data, setStep3Data] = useState({
    cc: { pdt: 0, pdrt: 0 },
    ci: { pdt: 0, pdrt: 0 },
    ou: { pdt: 0, pdrt: 0 },
    tcc: { pdt: 0, pdrt: 0 },
    tcd: { pdt: 0, pdrt: 0 },
  });

  const [step4Data, setStep4Data] = useState({
    cgp: 0,
    iif: 0,
  });
  const [step5Data, setStep5Data] = useState([]);
  const [step6Data, setStep6Data] = useState([]);
  const [step7Data, setStep7Data] = useState([]);
  const [step9Data, setStep9Data] = useState({ saidas: [] });

  const formatCurrency = (value) =>
    value?.toLocaleString("pt-BR", { minimumFractionDigits: 2 }) ?? "0,00";

  // const isAbove = (status) => status === "above";

  const generateIndicatorsPDF = async () => {
    const sections = document.querySelectorAll("#pdf-indicators .pdf-section");
    const pdf = new jsPDF("p", "mm", "a4");

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    for (let i = 0; i < sections.length; i++) {
      const section = sections[i];

      const canvas = await html2canvas(section, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
        windowWidth: section.scrollWidth,
        windowHeight: section.scrollHeight,
      });

      const imgData = canvas.toDataURL("image/png");

      // const y = i === 0 ? 0 : margin; --- MÉTODO ANTIGO ---

      if (i > 0) pdf.addPage();

      pdf.addImage(imgData, "PNG", 0, 0, pageWidth, pageHeight);
    }

    eventTag(eventGA?.name, eventGA?.category, "download", `Relatório mês: ${date}`)
    pdf.save("indicadores.pdf");
  };

  const INDICATOR_MAP = {
    capacidadePagamento: indicators.desempenho?.capacidade_de_pagamento,
    receitaMensal: indicators.desempenho?.receita_mensal,
    lucroMensal: indicators.desempenho?.lucro_mensal,
    lucratividade: indicators.desempenho?.lucratividade,
    rentabilidade: indicators.desempenho?.rentabilidade,
    ncg: indicators.desempenho?.necessidade_de_capital_de_giro,
    nfcg: indicators.desempenho?.necessidade_de_formacao_de_capital_de_giro,

    inadimplencia: indicators.endividamento?.inadimplencia,
    cml: indicators.endividamento?.cml,
    gee: indicators.endividamento?.gee,
  };

  const getIndicator = (key) => {
    const raw = INDICATOR_MAP[key];
    if (!raw) return null;

    return {
      projetada:
        raw.projetada ??
        raw.projetado ??
        raw.planejada ??
        raw.planejado ??
        null,
      alcancada: raw.alcancada ?? raw.alcancado ?? null,
      status: raw.status ?? null,
      meses: raw.meses ?? [],
    };
  };

  const getChart = (key) => {
    const indicator = getIndicator(key);
    if (!indicator || !indicator.meses) return [];

    return indicator.meses
      .filter((m) => {
        const d = parseMMYYYY(m.mes);
        if (!d) return false;

        if (filterRange.start && !sameOrAfter(d, filterRange.start))
          return false;
        if (filterRange.end && !sameOrBefore(d, filterRange.end)) return false;

        return true;
      })
      .map((m) => ({
        mes: m.mes,
        projetado: m.projetada ?? m.projetado ?? m.planejada ?? 0,
        alcancado: m.alcancada ?? m.alcancado ?? 0,
      }));
  };

  const changeTabs = (action, index) => {
    const stepName = StepIndicators.find(item => item.action === action)?.label
    eventTag(eventGA?.name, eventGA?.category, eventGA?.action, `Tab: ${stepName}`)
    setStepActive(index);
  };

  const updateIndicatorsFromResponse = (responseData) => {
    setIndicators((prev) => ({
      desempenho: {
        ...prev.desempenho,
        ...responseData.indicadores_de_desempenho,
      },
      endividamento: {
        ...prev.endividamento,
        ...responseData.indicadores_de_endividamento,
      },
      matriz: {
        ...prev.matriz,
        ...responseData.matriz_de_avaliacao_economica_do_endividamento,
      },
    }));
  };

  const updateStepData = async (stepNumber, stepData) => {
    setUpdatingStep(stepNumber);

    try {
      let s2 = step2Data;
      let s3 = step3Data;
      let s4 = step4Data;
      let s5 = step5Data;
      let s6 = step6Data;
      let s7 = step7Data;
      let s9 = step9Data;
      let title = ''

      switch (stepNumber) {
        case 2:
          s2 = stepData;
          title = 'Média Mensal'
          setStep2Data(stepData);
          break;
        case 3:
          s3 = stepData;
          title = 'Custos Indiretos Variáveis'
          setStep3Data(stepData);
          break;
        case 4:
          s4 = stepData;
          title = 'Investimento Total'
          setStep4Data(stepData);
          break;
        case 5:
          s5 = stepData;
          title = 'Prazos de Recebimento'
          setStep5Data(stepData);
          break;
        case 6:
          s6 = stepData;
          title = 'Prazos de Pagamento'
          setStep6Data(stepData);
          break;
        case 7:
          s7 = stepData;
          title = 'Giro de Estoque'
          setStep7Data(stepData);
          break;
        case 9:
          s9 = stepData;
          title = 'Fluxo de caixa projetado'
          setStep9Data(stepData);
          break;
        default:
          throw new Error(`Step ${stepNumber} não suportado`);
      }

      const parts = [
        formatStep2ForSave(s2),
        formatStep3ForSave(s3),
        formatStep4ForSave(s4),
        formatStep5ForSave(s5),
        formatStep6ForSave(s6),
        formatStep7ForSave(s7),
        formatStep9ForSave(s9),
      ];

      const formattedData = parts.reduce((acc, part) => {
        if (!part) return acc;

        Object.entries(part).forEach(([key, value]) => {
          if (key === "data" && value && typeof value === "object") {
            acc.data = {
              ...(acc.data || {}),
              ...value,
            };
          } else if (
            value &&
            typeof value === "object" &&
            !Array.isArray(value) &&
            acc[key] &&
            typeof acc[key] === "object" &&
            !Array.isArray(acc[key])
          ) {
            acc[key] = {
              ...acc[key],
              ...value,
            };
          } else {
            acc[key] = value;
          }
        });

        return acc;
      }, {});

      const response = await apiPlannings.updatePostCreditMonthData(
        monthId,
        formattedData,
      );

      if (response.data) {
        updateIndicatorsFromResponse(response.data);
        eventTag(eventGA?.name, eventGA?.category, "submit", `Atualizando: ${title}`)

        toast.success(
          <ToastContent
            description="Dados atualizados com sucesso!"
            title="Sucesso!"
          />,
        );

      }
    } catch (error) {
      toast.error(
        <ToastContent
          description={error.message || "Não foi possível atualizar os dados."}
          title="Erro!"
        />,
      );
    } finally {
      setUpdatingStep(null);
    }
  };

  const handleStep2Submit = (data) => {
    updateStepData(2, data || step2Data);
  };

  const handleStep3Submit = (data) => {
    updateStepData(3, data || step3Data);
  };

  const handleStep4Submit = (data) => {
    updateStepData(4, data || step4Data);
  };

  const handleStep5Submit = (data) => {
    updateStepData(5, data || step5Data);
  };

  const handleStep6Submit = (data) => {
    updateStepData(6, data || step6Data);
  };

  const handleStep7Submit = (data) => {
    updateStepData(7, data || step7Data);
  };

  const handleStep9Submit = (data) => {
    updateStepData(9, data || step9Data);
  };

  const parseMMYYYY = (value) => {
    if (!value || typeof value !== "string") return null;
    const [month, year] = value.split("/");
    const d = new Date(Number(year), Number(month) - 1, 1);
    return isNaN(d.getTime()) ? null : d;
  };

  const sameOrAfter = (a, b) => {
    if (!a || !b) return true;
    return a.getTime() >= b.getTime();
  };

  const sameOrBefore = (a, b) => {
    if (!a || !b) return true;
    return a.getTime() <= b.getTime();
  };

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => setAnimationInProgress(true), 10);
      document.body.style.overflow = "hidden";
    } else {
      setAnimationInProgress(false);
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) {
      setLoading(true);
      apiPlannings
        .getPostCreditMonth(monthId)
        .then((response) => {
          setPlanningData(response.data);
          setIsCompleted(response.data?.status === "completed");
          setRole(response.data?.role);
          setPdfInfo(response.data?.info || null);

          const apiData = response.data;
          const indicadoresMeses =
            apiData.indicators?.indicadores_de_desempenho
              ?.capacidade_de_pagamento?.meses || [];

          const availableMonths = indicadoresMeses
            .map((m) => parseMMYYYY(m.mes))
            .filter(Boolean)
            .sort((a, b) => a - b);

          const totalMonths = availableMonths.length;

          if (totalMonths <= 1) {
            setShowDateFilter(false);

            setRangeLimits({
              minStart: availableMonths[0] || null,
              maxEnd: availableMonths[0] || null,
            });

            setFilterRange({
              start: availableMonths[0] || null,
              end: availableMonths[0] || null,
            });
          } else {
            setShowDateFilter(true);

            const firstMonth = availableMonths[0];
            const lastMonth = availableMonths[availableMonths.length - 1];

            setRangeLimits({
              minStart: firstMonth,
              maxEnd: lastMonth,
            });
            setFilterRange({
              start: firstMonth,
              end: lastMonth,
            });
          }

          const formModel = transformDataToFormModel(response.data);
          setStep2Data(formModel.step2);
          setStep3Data(formModel.step3);
          setStep4Data(formModel.step4);
          setStep5Data(formModel.step5);
          setStep6Data(formModel.step6);
          setStep7Data(formModel.step7);
          setStep9Data(formModel.step9?.saidas);

          const apiIndicators = response.data.indicators;
          setIndicators({
            desempenho: apiIndicators.indicadores_de_desempenho,
            endividamento: apiIndicators.indicadores_de_endividamento,
            matriz:
            apiIndicators.matriz_de_avaliacao_economica_do_endividamento,
          });

          setLoading(false);
        })
        .catch((error) => {
          toast.error(
            <ToastContent
              description={
                error.message ||
                "Não foi possível carregar os dados do planejamento."
              }
              title="Erro!"
            />,
          );
          setLoading(false);
          setOpenModal(false);
        });
    }
  }, [isOpen, monthId, setOpenModal]);

  const onClose = () => {
    setAnimationInProgress(false);
    setTimeout(() => handleClose(), 300);
    setIsCollapsed(false);
    refreshPlannings();
    eventTag(eventGA?.name, eventGA?.category, eventGA?.action, `Voltar`)
  };

  const collapseInfoBox = () => {
    setIsCollapsed(true);
  };

  const handleStepChange = (stepSetter) => (key, value) => {
    if (key === null && typeof value === "object") {
      stepSetter(value);
    } else {
      stepSetter((prev) => {
        const keys = key.split(".");
        if (keys.length === 2) {
          return {
            ...prev,
            [keys[0]]: {
              ...prev[keys[0]],
              [keys[1]]: value,
            },
          };
        }
        return {
          ...prev,
          [key]: value,
        };
      });
    }
  };

  const handleArrayStepChange = (stepSetter) => (data) => {
    if (Array.isArray(data)) {
      stepSetter(data);
    }
  };

  const handleAccordionToggle = (sectionId) => {
    setOpenedSections((prev) => {
      if (prev.includes(sectionId)) {
        return prev.filter((id) => id !== sectionId);
      } else {
        const newSections = [...prev, sectionId];
        if (sectionId === "projected-cash-flow") {
          setCashFlowInfoCollapsed(false);
        }
        return newSections;
      }
    });
  };
  const gaAccordion = (title) => {
    eventTag(eventGA?.name, eventGA?.category, eventGA?.action, `Accordion: ${title}`)
  }
  const currentCompany = companies.find((company) => company.isActive === true);
  const renderHeaderInfo = () => {
    const name = currentCompany?.name ?? token?.name;
    return (
      <>
        {name && `${name} - `}
        {planningTitle && `${planningTitle} - `}
        {planningId && `ID: ${planningId}`}
      </>
    );
  };

  const finishMonthForm = () => {
    setLoading(true);
    setOpenedSections([]);
    const payload = formatCloseMonthData({
      step2: step2Data,
      step3: step3Data,
      step4: step4Data,
      step5: step5Data,
      step6: step6Data,
      step7: step7Data,
      step9: step9Data,
    });

    apiPlannings
      .closePostCreditMonth(monthId, payload)
      .then((response) => {
        setClosedMonth(true);
        setIsCompleted(true);

        if (response.data?.indicators) {
          setIndicators({
            desempenho: response.data.indicators.indicadores_de_desempenho,
            endividamento:
            response.data.indicators.indicadores_de_endividamento,
            matriz:
            response.data.indicators
              .matriz_de_avaliacao_economica_do_endividamento,
          });
        }

        if (response.data?.closed_at) {
          setPlanningData((prev) => ({
            ...prev,
            closed_at: response.data.closed_at,
          }));
        }

        toast.success(
          <ToastContent
            title="Sucesso!"
            description="Mês finalizado com sucesso!"
          />,
        )
        eventTag(eventGA?.name, eventGA?.category, "submit", `Fechando o mês: ${date}`)

      })
      .catch((error) => {
        toast.error(
          <ToastContent
            title="Erro!"
            description={error.message || "Não foi possível finalizar o mês."}
          />,
        );
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  if (!isOpen) return null;

  const IndicatorBlock = ({
                            indicatorKey,
                            title,
                            currency = false,
                            percent = false,
                            none = false,
                          }) => {
    const ind = getIndicator(indicatorKey);
    const chart = getChart(indicatorKey);

    const formatValue = (n) => {
      if (n == null) return "--";

      if (none) return n;
      if (percent) return `${n}%`;
      if (currency) return `R$ ${formatCurrency(n)}`;
      return n;
    };

    const hideProjected = indicatorKey === "inadimplencia";

    return (
      <div className="data">
        <div className="data-values">
          {!hideProjected && (
            <div className="data-values-projected">
              <h4>
                {title}{" "}
                {indicatorKey === "lucroMensal" ? "Projetado" : "Projetada"}
              </h4>
              <span className="value">
                {formatValue(
                  ind?.projetada?.toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
                )}
              </span>
            </div>
          )}

          <div className="data-values-reached">
            <h4>
              {title}{" "}
              {indicatorKey === "lucroMensal" ? "Alcançado" : "Alcançada"}
            </h4>
            <span className="value">
              {formatValue(
                ind?.alcancada?.toLocaleString("pt-BR", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }),
              )}
            </span>

            {!hideProjected && ind?.alcancada !== ind?.projetada && (
              <p
                className={ind?.alcancada > ind?.projetada ? "above" : "below"}
              >
                {ind?.alcancada > ind?.projetada
                  ? "Acima do projetado"
                  : "Abaixo do projetado"}
              </p>
            )}
          </div>
        </div>

        <div className="data-graphic">
          <Chart
            data={chart}
            type={
              none
                ? "none"
                : percent
                  ? "percent"
                  : currency
                    ? "currency"
                    : "currency"
            }
            hideProjected={hideProjected}
          />
        </div>
      </div>
    );
  };

  return (
    <div
      id="post-credit-plan"
      className={animationInProgress ? "modal-open" : ""}
    >
      {loading ? (
        <Loading />
      ) : (
        <div className="container">
          <div className="header">
            <div className="header-middle">
              <img src={PlanejadoraLogo} alt="Logo da Planejadora" />
              <h2>{date}</h2>
              <h4>{planningData.title}</h4>
            </div>
            <div>
              <BaSeButton
                onClick={onClose}
                type="secondary"
                value="Voltar"
                color="#2E5DE6"
                isBold
              />
            </div>
          </div>
          {firstMonth && (
            <div
              className={`information-box ${isCollapsed ? "collapsed" : ""}`}
            >
              <div className="information-box-header">
                <h4>Bem-vindo(a)!</h4>
                <BaSeIcon
                  color="#2E5DE6"
                  description="Fechar informações"
                  name="close"
                  onClick={collapseInfoBox}
                  size={16}
                />
              </div>
              <div className="information-box-texts">
                <p>
                  Este é o <span>primeiro passo</span> do{" "}
                  <span>monitoramento</span> do seu negócio.
                </p>
                <p>
                  Como este é o seu primeiro mês, o planejamento será igual ao
                  planejamento base, que serve como ponto de partida. A partir
                  do segundo mês, você deverá preencher e atualizar as
                  informações para acompanhar a evolução dos resultados e manter
                  o monitoramento sempre atualizado.
                </p>
              </div>
            </div>
          )}
          <div className="double-container">
            <div className="left-container">
              <div className="left-container-title">
                <h3>Dados do seu negócio</h3>
                <p>
                  Atualize as informações reais sobre o seu negócio para o
                  cálculo dos indicadores alcançados neste mês.
                </p>
              </div>

              <AccordionGraphics
                title="Média Mensal"
                titleSize={16}
                isOpen={openedSections.includes("monthly-average")}
                onToggle={() => {
                  handleAccordionToggle("monthly-average")
                  gaAccordion('Média Mensal')
                }}
              >
                <MonthlyAverage
                  data={step2Data}
                  isDisabled={role === "visualizador" || updatingStep === 2}
                  onChange={handleStepChange(setStep2Data)}
                  onSubmit={handleStep2Submit}
                  postCredit
                />
              </AccordionGraphics>

              <AccordionGraphics
                title="Custos Indiretos Variáveis"
                titleSize={16}
                isOpen={openedSections.includes("variable-indirect-costs")}
                onToggle={() => {
                  handleAccordionToggle("variable-indirect-costs")
                  gaAccordion('Custos Indiretos Variáveis')
                }}
              >
                <VariableIndirectCosts
                  data={step3Data}
                  isDisabled={role === "visualizador" || updatingStep === 3}
                  onChange={handleStepChange(setStep3Data)}
                  onSubmit={handleStep3Submit}
                  postCredit
                />
              </AccordionGraphics>

              <AccordionGraphics
                title="Investimento Total"
                titleSize={16}
                isOpen={openedSections.includes("total-investment")}
                onToggle={() => {
                  handleAccordionToggle("total-investment")
                  gaAccordion('Investimento Total')
                }}
              >
                <TotalInvestment
                  data={step4Data}
                  isDisabled={role === "visualizador" || updatingStep === 4}
                  onChange={handleStepChange(setStep4Data)}
                  onSubmit={handleStep4Submit}
                  postCredit
                  isAccordionOpen={openedSections.includes("total-investment")}
                />
              </AccordionGraphics>

              <AccordionGraphics
                title="Prazos de Recebimento"
                titleSize={16}
                isOpen={openedSections.includes("receivement-deadlines")}
                onToggle={() => {
                  handleAccordionToggle("receivement-deadlines")
                  gaAccordion('Prazos de Recebimento')
                }}
              >
                <PostCreditSection
                  step={5}
                  data={step5Data}
                  onChange={handleArrayStepChange(setStep5Data)}
                  onSubmit={handleStep5Submit}
                  isDisabled={role === "visualizador" || updatingStep === 5}
                />
              </AccordionGraphics>

              <AccordionGraphics
                title="Prazos de Pagamento"
                titleSize={16}
                isOpen={openedSections.includes("payment-deadlines")}
                onToggle={() => {
                  handleAccordionToggle("payment-deadlines")
                  gaAccordion('Prazos de Pagamento')
                }}
              >
                <PostCreditSection
                  step={6}
                  data={step6Data}
                  onChange={handleArrayStepChange(setStep6Data)}
                  onSubmit={handleStep6Submit}
                  isDisabled={role === "visualizador" || updatingStep === 6}
                />
              </AccordionGraphics>

              <AccordionGraphics
                title="Giro de Estoque"
                titleSize={16}
                isOpen={openedSections.includes("inventory-turnover")}
                onToggle={() => {
                  handleAccordionToggle("inventory-turnover")
                  gaAccordion('Giro de Estoque')
                }}
              >
                <PostCreditSection
                  step={7}
                  data={step7Data}
                  onChange={handleArrayStepChange(setStep7Data)}
                  onSubmit={handleStep7Submit}
                  isDisabled={role === "visualizador" || updatingStep === 7}
                />
              </AccordionGraphics>

              <AccordionGraphics
                title="Fluxo de caixa projetado"
                titleSize={16}
                isOpen={openedSections.includes("projected-cash-flow")}
                onToggle={() => {
                  handleAccordionToggle("projected-cash-flow")
                  gaAccordion('Fluxo de caixa projetado')
                }}
              >
                <PostCreditCashFlow
                  date={date}
                  data={step9Data}
                  onChange={handleArrayStepChange(setStep9Data)}
                  onSubmit={handleStep9Submit}
                  isDisabled={role === "visualizador"}
                  isCollapsed={cashFlowInfoCollapsed}
                  onCollapse={() => setCashFlowInfoCollapsed(true)}
                />
              </AccordionGraphics>
              <div className="finish-month">
                {closedMonth ? (
                  <div className="finish-month-info">
                    <div className="finish-month-info-header">
                      <BaSeIcon
                        name="comment-alt-notes"
                        size={16}
                        color="#2E5DE6"
                        description="icon de mês finalizado"
                      />
                      <h4>Você já fechou o mês</h4>
                    </div>
                    <div className="finish-month-info-texts">
                      <p>
                        Seu monitoramento foi fechado no dia{" "}
                        {moment(planningData.closed_at).format("DD/MM/YYYY")}.
                      </p>
                      <p>
                        Agora você pode gerar seu relatório ou pode trabalhar no
                        monitoramento do próximo mês.
                      </p>
                    </div>
                  </div>
                ) : (
                  <Button
                    callback={finishMonthForm}
                    maxWidth={156}
                    disabled={loading || role === "visualizador"}
                    isPrimary={true}
                  >
                    Fechar o mês
                  </Button>
                )}
              </div>
            </div>
            <div className="right-container">
              <div className="right-container-header">
                <h2>Meus indicadores</h2>
                <Button
                  isPrimary
                  disabled={!isCompleted}
                  callback={() => generateIndicatorsPDF()}
                >
                  Gerar Relatório
                </Button>
              </div>
              <p className="right-container-description">
                Acompanhe a evolução dos indicadores financeiros da sua empresa.
              </p>
              <div className="payment-capacity">
                <h4>Capacidade de pagamento</h4>
                <div className="data">
                  <div className="data-values">
                    <div className="data-values-projected">
                      <h4>Capacidade de Pagamento Projetada</h4>
                      <span className="value">
                        R${" "}
                        {indicators.desempenho?.capacidade_de_pagamento.projetada?.toLocaleString(
                          "pt-BR",
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          },
                        )}
                      </span>
                    </div>

                    <div className="data-values-reached">
                      <h4>Capacidade de Pagamento Alcançada</h4>
                      <span className="value">
                        R${" "}
                        {indicators.desempenho?.capacidade_de_pagamento.alcancada?.toLocaleString(
                          "pt-BR",
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          },
                        )}
                      </span>

                      {indicators.desempenho?.capacidade_de_pagamento
                          .alcancada !==
                        indicators.desempenho?.capacidade_de_pagamento
                          .projetada && (
                          <p
                            className={
                              indicators.desempenho?.capacidade_de_pagamento
                                .status === "above"
                                ? "above"
                                : "below"
                            }
                          >
                            {indicators.desempenho?.capacidade_de_pagamento
                              .status === "above"
                              ? "Acima do projetado"
                              : "Abaixo do projetado"}
                          </p>
                        )}
                    </div>
                  </div>

                  <div className="data-graphic">
                    <ChartSingleBar
                      indicator={indicators.desempenho?.capacidade_de_pagamento}
                    />
                  </div>
                </div>
              </div>
              <div className="step-components-area">
                <StepComponent
                  stepActive={stepActive}
                  filterType={changeTabs}
                  listSteps={StepIndicators}
                />
              </div>

              {showDateFilter && (
                <div className="date-area">
                  <BaSeDatePicker
                    calendarType="months"
                    startDate={filterRange.start}
                    minDate={rangeLimits.minStart}
                    maxDate={filterRange.end || rangeLimits.maxEnd}
                    label="Data inicial"
                    placeholder="Data inicial"
                    onStartDateChange={(value) => {
                      if (value instanceof Date && !isNaN(value)) {
                        setFilterRange((prev) => ({ ...prev, start: value }));
                      }
                    }}
                  />

                  <BaSeDatePicker
                    calendarType="months"
                    startDate={filterRange.end}
                    minDate={filterRange.start || rangeLimits.minStart}
                    maxDate={rangeLimits.maxEnd}
                    label="Data final"
                    placeholder="Data final"
                    onStartDateChange={(value) => {
                      if (value instanceof Date && !isNaN(value)) {
                        setFilterRange((prev) => ({ ...prev, end: value }));
                      }
                    }}
                  />
                </div>
              )}
              {stepActive ? (
                <>
                  <AccordionGraphics
                    boxShadow
                    weight={700}
                    titleSize={27}
                    title="Matriz de avaliação econômica do endividamento"
                    marginBottom="24px"
                    isOpen={openedSections.includes("matriz")}
                    onToggle={() => {
                      handleAccordionToggle("matriz")
                      gaAccordion('Matriz de avaliação econômica do endividamento')
                    }}
                  >
                    <div className="right-container-info">
                      {/* Nota: Comentado para evento do SEBRAE */}
                      {/* <div className="data-values-matriz">
                        <h4>Risco de Endividamento Econômico </h4>
                        <span className="value">
                          {
                            indicators.matriz
                              ?.risco_de_endividamento_economico_percentual
                          }
                          %
                        </span>

                        <p
                          className={
                            "nivel " +
                            (indicators.matriz
                              ?.risco_de_endividamento_economico_nivel ===
                            "Baixo"
                              ? "baixo"
                              : indicators.matriz
                                    ?.risco_de_endividamento_economico_nivel ===
                                  "Moderado"
                                ? "moderado"
                                : indicators.matriz
                                      ?.risco_de_endividamento_economico_nivel ===
                                    "Alto"
                                  ? "alto"
                                  : "critico")
                          }
                        >
                          {indicators.matriz
                            ?.risco_de_endividamento_economico_nivel ===
                          "Baixo"
                            ? "Baixo"
                            : indicators.matriz
                                  ?.risco_de_endividamento_economico_nivel ===
                                "Moderado"
                              ? "Moderado"
                              : indicators.matriz
                                    ?.risco_de_endividamento_economico_nivel ===
                                  "Alto"
                                ? "Alto"
                                : "Crítico"}
                        </p>
                      </div> */}

                      <Matriz
                        cml={indicators.matriz.cml}
                        gee={indicators.matriz.gee}
                      />
                    </div>
                  </AccordionGraphics>
                  <AccordionGraphics
                    boxShadow
                    weight={700}
                    titleSize={27}
                    title="Inadimplência"
                    marginBottom="24px"
                    isOpen={openedSections.includes("defaulting")}
                    onToggle={() => {
                      handleAccordionToggle("defaulting")
                      gaAccordion('Inadimplência')
                    }}
                    tooltip={{
                      title: "Inadimplência",
                      message: inadimplenciaMessage,
                      type: "popover",
                      direction: "bottom",
                      alertSize: 315,
                    }}
                  >
                    <div className="right-container-info">
                      <p>Quantidade de parcelas em atraso.</p>

                      <IndicatorBlock
                        indicatorKey="inadimplencia"
                        title="Inadimplência"
                        percent={true}
                      />
                    </div>
                  </AccordionGraphics>
                  <AccordionGraphics
                    boxShadow
                    weight={700}
                    titleSize={27}
                    title="Comprometimento Percentual da Capacidade de Pagamento Mensal"
                    marginBottom="24px"
                    isOpen={openedSections.includes(
                      "percentage-commitment-of-monthly-payment-capacity",
                    )}
                    onToggle={() => {
                      handleAccordionToggle(
                        "percentage-commitment-of-monthly-payment-capacity",
                      )
                      gaAccordion('Comprometimento Percentual da Capacidade de Pagamento Mensal')
                    }}
                    tooltip={{
                      title:
                        "Comprometimento Percentual da Capacidade de Pagamento Mensal",
                      message: cmlMessage,
                      type: "popover",
                      direction: "bottom",
                      alertSize: 315,
                    }}
                  >
                    <div className="right-container-info">
                      <p>
                        Comprometimento percentual da Capacidade de Pagamento
                        Mensal Planejada.
                      </p>

                      <IndicatorBlock indicatorKey="cml" title="CML" percent />
                    </div>
                  </AccordionGraphics>
                  <AccordionGraphics
                    boxShadow
                    weight={700}
                    titleSize={27}
                    title="Grau de Endividamento Econômico"
                    marginBottom="24px"
                    isOpen={openedSections.includes(
                      "level-of-economic-indebtedness",
                    )}
                    onToggle={() => {
                      handleAccordionToggle("level-of-economic-indebtedness")
                      gaAccordion('Grau de Endividamento Econômico')
                    }}
                    tooltip={{
                      title: "Grau de Endividamento Econômico",
                      message: geeMessage,
                      type: "popover",
                      direction: "bottom",
                      alertSize: 315,
                    }}
                  >
                    <div className="right-container-info">
                      <p>
                        <strong>Dívida Total</strong> (saldo de todos os
                        empréstimos, financiamentos e obrigações assumidas
                        (formais e informais) / <br />{" "}
                        <strong>Receita Anual</strong> (faturamento bruto médio
                        anual (ou estimativa realista)
                      </p>

                      <IndicatorBlock
                        indicatorKey="gee"
                        title="GEE"
                        none={true}
                      />
                    </div>
                  </AccordionGraphics>
                </>
              ) : (
                <>
                  <AccordionGraphics
                    boxShadow
                    weight={700}
                    titleSize={27}
                    title="Receita"
                    marginBottom="24px"
                    isOpen={openedSections.includes("revenue")}
                    onToggle={() => {
                      handleAccordionToggle("revenue")
                      gaAccordion('Receita')
                    }}
                  >
                    <div className="right-container-info">
                      <p>Faturamento bruto mensal realizado.</p>

                      <IndicatorBlock
                        indicatorKey="receitaMensal"
                        title="Receita Mensal"
                        currency
                      />
                    </div>
                  </AccordionGraphics>

                  <AccordionGraphics
                    boxShadow
                    weight={700}
                    titleSize={27}
                    title="Lucro"
                    marginBottom="24px"
                    isOpen={openedSections.includes("profit")}
                    onToggle={() => {
                      handleAccordionToggle("profit")
                      gaAccordion('Lucro')
                    }}
                    tooltip={{
                      title: "Lucro",
                      message: lucroMessage,
                      type: "popover",
                      direction: "bottom",
                      alertSize: 315,
                    }}
                  >
                    <div className="right-container-info">
                      <p>Resultado econômico líquido mensal.</p>

                      <IndicatorBlock
                        indicatorKey="lucroMensal"
                        title="Lucro Mensal"
                        currency
                      />
                    </div>
                  </AccordionGraphics>

                  <AccordionGraphics
                    boxShadow
                    weight={700}
                    titleSize={27}
                    title="Lucratividade"
                    marginBottom="24px"
                    isOpen={openedSections.includes("profitability")}
                    onToggle={() => {
                      handleAccordionToggle("profitability")
                      gaAccordion('Lucratividade')
                    }}
                    tooltip={{
                      title: "Lucratividade",
                      message: lucratividadeMessage,
                      type: "popover",
                      direction: "bottom",
                      alertSize: 315,
                    }}
                  >
                    <div className="right-container-info">
                      <p>Lucro dividido pela Receita.</p>

                      <IndicatorBlock
                        indicatorKey="lucratividade"
                        title="Lucratividade"
                        percent
                      />
                    </div>
                  </AccordionGraphics>

                  <AccordionGraphics
                    boxShadow
                    weight={700}
                    titleSize={27}
                    title="Rentabilidade"
                    marginBottom="24px"
                    isOpen={openedSections.includes("rate-of-return")}
                    onToggle={() => {
                      handleAccordionToggle("rate-of-return")
                      gaAccordion('Rentabilidade')
                    }}
                    tooltip={{
                      title: "Rentabilidade",
                      message: rentabilidadeMessage,
                      type: "popover",
                      direction: "bottom",
                      alertSize: 315,
                    }}
                  >
                    <div className="right-container-info">
                      <p>
                        Lucro em relação ao capital investido; mede retorno
                        sobre investimento.
                      </p>

                      <IndicatorBlock
                        indicatorKey="rentabilidade"
                        title="Rentabilidade"
                        percent
                      />
                    </div>
                  </AccordionGraphics>
                  <AccordionGraphics
                    boxShadow
                    weight={700}
                    titleSize={27}
                    title="Necessidade de Capital de Giro"
                    marginBottom="24px"
                    isOpen={openedSections.includes(
                      "working-capital-requirement",
                    )}
                    onToggle={() => {
                      handleAccordionToggle("working-capital-requirement")
                      gaAccordion('Necessidade de Capital de Giro')
                    }}
                    tooltip={{
                      title: "Necessidade de Capital de Giro",
                      message: ncgMessage,
                      type: "popover",
                      direction: "bottom",
                      alertSize: 315,
                    }}
                  >
                    <div className="right-container-info">
                      <p>Capital mínimo exigido para sustentar operações.</p>

                      <IndicatorBlock
                        indicatorKey="ncg"
                        title="Necessidade de Capital de Giro"
                        currency
                      />
                    </div>
                  </AccordionGraphics>
                  <AccordionGraphics
                    boxShadow
                    weight={700}
                    titleSize={27}
                    title="Necessidade de Formação de Capital de Giro"
                    marginBottom="24px"
                    isOpen={openedSections.includes("working-capital-needs")}
                    onToggle={() => {
                      handleAccordionToggle("working-capital-needs")
                      gaAccordion('Necessidade de Formação de Capital de Giro')
                    }}
                    tooltip={{
                      title: "Necessidade de Formação de Capital de Giro",
                      message: nfcgMessage,
                      type: "popover",
                      direction: "bottom",
                      alertSize: 315,
                    }}
                  >
                    <div className="right-container-info">
                      <p>Capital mínimo exigido para sustentar operações.</p>

                      <IndicatorBlock
                        indicatorKey="nfcg"
                        title="Necessidade de Formação de Capital de Giro"
                        currency
                      />
                    </div>
                  </AccordionGraphics>
                </>
              )}
            </div>
          </div>
        </div>
      )}
      <PdfIndicators
        company={currentCompany}
        info={pdfInfo}
        pcDate={date}
        getChart={getChart}
        indicators={{ ...INDICATOR_MAP, matriz: indicators.matriz }}
        getIndicator={getIndicator}
        renderHeaderInfo={renderHeaderInfo}
        planId={planningId}
        monthId={monthId}
        planningTitle={planningTitle}
      />
    </div>
  );
};

export default PostCreditResult;
